export default "__VITE_ASSET__CVjdvzzJ__"